// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { InvoicingGet } from '../../../../types/server/modules/invoicing/get';

export type * from '../../../../types/server/modules/invoicing/get';

export const createGet = ( requests: Requests ): InvoicingGet => ({
  billing_entity_points_of_sale: ( params,headers ) => {
      return requests.get( `/billing-entity-points-of-sale`, params, headers );
    }
});
